import { useSlate as useEditor } from 'slate-react';

export default useEditor;
